var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-sorting-card.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
var XSortingCard = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.sortingNumber = -1;
    this.sortingDirection = "desc";
  }
  styles() {
    return [
      {
        ".close": {
          color: "red",
          opacity: "0"
        },
        ".card": {
          marginLeft: this.spacing.sm,
          background: "white",
          borderRadius: "2rem",
          paddingInline: this.spacing.sm,
          cursor: "pointer",
          "&:hover > .close": {
            opacity: "1"
          }
        },
        ".no-select": {
          "-webkit-touch-callout": "none",
          "-webkit-user-select": "none",
          "user-select": "none"
        }
      }
    ];
  }
  render() {
    return html`
      <x-flex class="card no-select" horizontal center crossaxis-center>
        <x-text @click=${() => this._toggleSortingDirection()}> ${this.sortingNumber + 1} </x-text>
        <x-icon ${css({ fontSize: "1.4rem" })} @click=${() => this._toggleSortingDirection()}>
          ${this.sortingDirection === "asc" ? "expand_less" : "expand_more"}
        </x-icon>
        <x-icon
          class="close"
          @click=${() => {
      const event = new CustomEvent("closed", {
        detail: {
          sortingNumber: this.sortingNumber
        }
      });
      this.dispatchEvent(event);
    }}
        >
          close
        </x-icon>
      </x-flex>
    `;
  }
  _toggleSortingDirection() {
    this.sortingDirection = this.sortingDirection === "asc" ? "desc" : "asc";
    this.requestUpdate();
    const event = new CustomEvent("updated", {
      detail: {
        sortingNumber: this.sortingNumber,
        sortingDirection: this.sortingDirection
      }
    });
    this.dispatchEvent(event);
  }
};
__decorateClass([
  property()
], XSortingCard.prototype, "sortingNumber", 2);
__decorateClass([
  property()
], XSortingCard.prototype, "sortingDirection", 2);
XSortingCard = __decorateClass([
  customElement("x-sorting-card")
], XSortingCard);
export {
  XSortingCard
};
